'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _setInterval = require('common/utils/set-interval');

var _setInterval2 = _interopRequireDefault(_setInterval);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

require('./index.scss');

var Loader = _react2['default'].createClass({
    displayName: 'Loader',


    getInitialState: function getInitialState() {
        return {
            'numCircles': 5,
            'currentIndex': 0,
            'circleRadius': 10
        };
    },

    componentDidMount: function componentDidMount() {

        var numBubbles = this.refs.dots.querySelectorAll('circle').length;
        var i = 0;

        this._timer = (0, _setInterval2['default'])(function () {
            this.setState({
                'currentCircleIndex': i
            });
            i = (i + 1) % numBubbles;
        }.bind(this), 500);
    },

    componentWillUnmount: function componentWillUnmount() {
        clearInterval(this._timer);
    },

    render: function render() {

        var circles = [];
        var radius = this.state.circleRadius;
        var circWidth = radius * 2;
        var padding = radius;

        // width and padding
        var wandp = circWidth + padding;

        for (var i = this.state.numCircles; i--;) {
            circles.push(_react2['default'].createElement('circle', {
                key: 'circle' + i,
                className: i === this.state.currentCircleIndex ? 'current-dot' : void 0,
                ref: '5',
                cx: wandp * i + radius,
                cy: radius,
                r: radius }));
        }

        var width = wandp * circles.length - padding;
        var classNames = ' m-loader-dots whitelabel-dot-loader';

        if (this.props.className) {
            classNames += ' ' + this.props.className;
        }

        return _jsx('div', {
            className: classNames
        }, void 0, _jsx('svg', {
            width: '100%',
            viewBox: '0 0 ' + width + ' ' + circWidth,
            version: '1.1'
        }, void 0, _react2['default'].createElement(
            'g',
            { ref: 'dots' },
            circles
        )), this.props.children ? _jsx('span', {
            className: 'message'
        }, void 0, this.props.children) : void 0);
    }

});

module.exports = Loader;


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/components/common/loader/index.jsx
 ** module id = 682
 ** module chunks = 0
 **/